/*
  K9 Power Size Guide ("Find your fit") - markup: snippets/size-guide.liquid, data: snippets/size-guide-data.liquid.
  Generic: reads the recommendation rows and the product's variants / Recharge selling plans from the page and
  holds no product-specific values or IDs.

  Recommendation -> purchase:
    size  "8 oz" / "1 lb" / "3 lb"  ->  the Size variant with that size ("1 Pound (45 Scoops)" = "1 lb")
    days  45                        ->  that variant's selling plan whose "Order Frequency and Unit" is "45-day"
    qty   2                         ->  quantity
  If the size, the plan or a single unambiguous match is missing, the button stays disabled and the reason is
  logged to the console ([Size Guide]) - nothing is guessed.
  Any recommendation whose bag size is 3 lb (DEAL_SIZE, any product) also shows "Best Savings plus Free Shipping!".
  3 Pack (ITG): a recommendation whose size is "3 Pack" - or "3 lb" on a product that has no 3 lb variant (Young at Heart) -
  is bought as the separate "<handle>-3-pack" product (data-k9-sg-pack in snippets/size-guide.liquid): its variant + the
  selling plan for that interval, shown as "3 Pack (3 × 1 lb bags)", and it also shows "Best Savings plus Free Shipping!".
*/
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('k9-size-guide')) return;

  var LOG = '[Size Guide]';
  var ANIMATION_MS = 320;
  /* recommended bag size (normalizeSize format) that shows "Best Savings plus Free Shipping!" - any product */
  var DEAL_SIZE = '3 lb';
  /* the separate 3 Pack product's size (normalizeSize format): "3 Pack" -> "3 pack" */
  var PACK_SIZE = '3 pack';
  var PACK_LABEL = '3 Pack (3 × 1 lb bags)';

  /* "1 Pound (45 Scoops)" -> "1 lb", "8 oz" -> "8 oz", "3 Pound" -> "3 lb" */
  function normalizeSize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\([^)]*\)/g, ' ')
      .replace(/\b(pounds?|lbs?)\b/g, 'lb')
      .replace(/\b(ounces?|oz)\b/g, 'oz')
      .replace(/(\d)\s*(lb|oz)\b/g, '$1 $2')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Recharge selling plan option "Order Frequency and Unit" = "45-day" -> 45 (only day intervals are accepted) */
  function planDays(plan) {
    var options = (plan && plan.options) || [];
    for (var i = 0; i < options.length; i++) {
      if (/frequency/i.test(options[i].name || '')) {
        var match = String(options[i].value || '').trim().match(/^(\d+)[\s-]*days?$/i);
        return match ? parseInt(match[1], 10) : null;
      }
    }
    return null;
  }

  /* Supply (days) shown as in the spreadsheet (one decimal), without a trailing ".0" */
  function formatSupply(value, decimals) {
    var text = Number(value).toFixed(decimals);
    return text.indexOf('.') === -1 ? text : text.replace(/\.?0+$/, '');
  }

  function unique(list) {
    var seen = {};
    return list.filter(function (item) {
      if (item == null || seen[item]) return false;
      seen[item] = true;
      return true;
    });
  }

  function addOptions(select, values, labels) {
    values.forEach(function (value) {
      var option = document.createElement('option');
      option.value = value;
      option.textContent = labels ? labels[value] : value;
      select.appendChild(option);
    });
  }

  function cartAddUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart/add.js';
  }

  /* same request the theme's product form sends (barracuda-cart.js: axios.post('/cart/add.js', data)) */
  function postCartAdd(payload) {
    if (window.axios && typeof window.axios.post === 'function') {
      return window.axios.post(cartAddUrl(), payload).then(function (response) { return response.data; });
    }
    return fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw { response: { status: response.status, data: data } };
        return data;
      });
    });
  }

  function errorMessage(error) {
    var data = error && error.response && error.response.data;
    var text = data && (typeof data.description === 'string' && data.description !== '[object Object]' ? data.description : data.message);
    return text || 'Sorry, we couldn’t add this to your cart. Please try again.';
  }

  class K9SizeGuide extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.dialog = this.querySelector('dialog');
      this.weightSelect = this.querySelector('[data-k9-sg-weight]');
      this.activityField = this.querySelector('[data-k9-sg-activity-field]');
      this.activitySelect = this.querySelector('[data-k9-sg-activity]');
      this.emptyText = this.querySelector('[data-k9-sg-empty]');
      this.sizeText = this.querySelector('[data-k9-sg-size]');
      this.dealText = this.querySelector('[data-k9-sg-deal]');
      this.freqText = this.querySelector('[data-k9-sg-freq]');
      this.supplyText = this.querySelector('[data-k9-sg-supply]');
      this.addButton = this.querySelector('[data-k9-sg-add]');
      this.message = this.querySelector('[data-k9-sg-msg]');
      this.addLabel = this.addButton.textContent;

      try {
        this.data = JSON.parse(this.querySelector('[data-k9-sg-data]').textContent);
        this.product = JSON.parse(this.querySelector('[data-k9-sg-product]').textContent);
        /* ITG 3 Pack: the separate <handle>-3-pack product, or null when it is not on the Online Store */
        var packData = this.querySelector('[data-k9-sg-pack]');
        this.pack = packData ? JSON.parse(packData.textContent || 'null') : null;
      } catch (error) {
        console.error(LOG, 'could not read the size guide data', error);
        return;
      }

      this.rows = this.data.rows || [];
      this.activities = unique(this.rows.map(function (row) { return row.activity; }));
      this.decimals = typeof this.data.supply_decimals === 'number' ? this.data.supply_decimals : 1;

      addOptions(this.weightSelect, unique(this.rows.map(function (row) { return row.weight; })), this.data.weights || {});
      if (this.activities.length) {
        addOptions(this.activitySelect, this.activities);
        this.activityField.hidden = false;
      }

      this.validate();

      this.weightSelect.addEventListener('change', this.update.bind(this));
      this.activitySelect.addEventListener('change', this.update.bind(this));
      this.addButton.addEventListener('click', this.addToCart.bind(this));
      this.querySelectorAll('[data-k9-sg-close]').forEach(function (button) {
        button.addEventListener('click', this.close.bind(this));
      }, this);
      /* a click on the backdrop lands on the dialog itself (the panel fills the dialog) */
      this.dialog.addEventListener('click', function (event) {
        if (event.target === this.dialog) this.close();
      }.bind(this));
      /* Esc: animate out instead of the instant native close */
      this.dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        this.close();
      }.bind(this));
    }

    /* ITG 3 Pack: the 3 Pack product's "3 Pack" variant (or its only variant) */
    packVariants() {
      var variants = (this.pack && this.pack.variants) || [];
      var named = variants.filter(function (variant) { return normalizeSize(variant.title) === PACK_SIZE; });
      return named.length ? named : (variants.length === 1 ? variants : []);
    }

    /* finds the variant + selling plan for a row; returns { variant, plan, qty } or { error } */
    resolve(row) {
      var sizeIndex = this.product.size_index;
      var wanted = normalizeSize(row.size);
      var variants = (this.product.variants || []).filter(function (variant) {
        var size = sizeIndex >= 0 && variant.options ? variant.options[sizeIndex] : variant.title;
        return normalizeSize(size) === wanted;
      });
      var isPack = false;
      /* ITG 3 Pack: "3 Pack" -> the separate 3 Pack product; "3 lb" with no 3 lb variant on this product -> the 3 Pack too */
      if (wanted === PACK_SIZE || (wanted === DEAL_SIZE && !variants.length && this.pack)) {
        if (!this.pack) return { pack: true, error: 'no 3 Pack product (' + this.product.handle + '-3-pack) on the Online Store' };
        variants = this.packVariants();
        isPack = true;
      }
      if (variants.length !== 1) {
        return { pack: isPack, error: variants.length ? 'more than one "' + row.size + '" variant' : 'no "' + row.size + '" variant on this product' };
      }
      var variant = variants[0];
      var plans = (variant.plans || []).filter(function (plan) { return planDays(plan) === row.days; });
      if (plans.length !== 1) {
        return {
          pack: isPack,
          variant: variant,
          error: plans.length
            ? 'more than one ' + row.days + '-day selling plan on "' + variant.title + '"'
            : 'no ' + row.days + '-day selling plan on "' + variant.title + '"'
        };
      }
      return { variant: variant, plan: plans[0], qty: row.qty, pack: isPack, productId: isPack ? this.pack.id : this.product.id };
    }

    /* logs every recommendation that cannot be bought (missing size / plan) once, on load */
    validate() {
      this.rows.forEach(function (row) {
        var result = this.resolve(row);
        var label = (this.data.weights || {})[row.weight] + (row.activity ? ' / ' + row.activity : '');
        if (result.error) {
          console.warn(LOG, this.product.handle + ' - ' + label + ': ' + result.error);
        } else if (!result.variant.available) {
          console.warn(LOG, this.product.handle + ' - ' + label + ': "' + result.variant.title + '" is sold out');
        }
      }, this);
    }

    selectedRow() {
      var weight = this.weightSelect.value;
      var activity = this.activities.length ? this.activitySelect.value : null;
      if (!weight || (this.activities.length && !activity)) return null;
      for (var i = 0; i < this.rows.length; i++) {
        var row = this.rows[i];
        if (row.weight === weight && (!this.activities.length || row.activity === activity)) return row;
      }
      return null;
    }

    showMessage(text) {
      this.message.textContent = text || '';
      this.message.hidden = !text;
    }

    update() {
      var row = this.selectedRow();
      this.showMessage('');
      this.current = null;
      this.addButton.disabled = true;
      ['variantId', 'sellingPlanId', 'quantity'].forEach(function (key) { delete this.addButton.dataset[key]; }, this);

      if (!row) {
        var waitingForActivity = this.weightSelect.value && this.activities.length && !this.activitySelect.value;
        this.emptyText.textContent = waitingForActivity
          ? 'Choose your dog’s activity level to see our recommendation.'
          : 'Choose your dog’s weight to see our recommendation.';
        this.emptyText.hidden = false;
        this.sizeText.hidden = this.freqText.hidden = this.supplyText.hidden = true;
        if (this.dealText) this.dealText.hidden = true;
        return;
      }

      this.emptyText.hidden = true;
      var result = this.resolve(row);
      /* ITG 3 Pack: shown as "3 Pack (3 × 1 lb bags)" (also for a "3 lb" row mapped to the 3 Pack) */
      this.sizeText.textContent = result.pack
        ? (row.qty > 1 ? row.qty + ' × ' + PACK_LABEL : PACK_LABEL)
        : (row.qty > 1 ? row.qty + ' × ' + row.size + ' bags' : row.size + ' bag');
      this.freqText.textContent = 'Delivered every ' + row.days + ' days';
      this.sizeText.hidden = this.freqText.hidden = false;
      /* any product: the savings callout follows the final recommended bag size */
      if (this.dealText) this.dealText.hidden = !(result.pack || normalizeSize(row.size) === DEAL_SIZE);
      if (row.supply === null || row.supply === undefined || row.supply === '') {
        this.supplyText.hidden = true;
      } else {
        /* optional daily serving + total scoops, e.g. 1.5 scoops/day x 90 days = 135 scoops */
        var serving = row.scoops && row.scoops_per_day ? ' (' + row.scoops + ' scoops at ' + row.scoops_per_day + ' scoops/day)' : '';
        this.supplyText.textContent = 'Approximately ' + formatSupply(row.supply, this.decimals) + ' days of daily support' + serving + '.';
        this.supplyText.hidden = false;
      }

      if (result.error) {
        this.showMessage('This recommendation isn’t available to order online right now.');
        return;
      }
      if (!result.variant.available) {
        this.showMessage(result.pack ? 'The 3 Pack is currently sold out.' : 'The ' + row.size + ' bag is currently sold out.');
        return;
      }
      this.current = result;
      this.addButton.dataset.variantId = result.variant.id;
      this.addButton.dataset.sellingPlanId = result.plan.id;
      this.addButton.dataset.quantity = result.qty;
      this.addButton.disabled = false;
    }

    addToCart(event) {
      if (this.busy || !this.current) return;
      var current = this.current;
      var payload = { items: [{ id: current.variant.id, quantity: current.qty, selling_plan: current.plan.id }] };

      this.busy = true;
      this.addButton.disabled = true;
      this.addButton.setAttribute('aria-busy', 'true');
      this.addButton.textContent = 'Adding…';
      this.showMessage('');

      postCartAdd(payload)
        .then(function (data) {
          /* the cart drawer takes over from here, so focus is not sent back to the Size Guide link */
          this.close({ restoreFocus: false });
          var cart = window.barracudaCart;
          if (cart) {
            try {
              cart.refreshCartIcon();
              cart.animateCartIcon();
              cart.openDrawer(event);
            } catch (error) {
              console.error(LOG, error);
            }
          }
          document.dispatchEvent(new CustomEvent('k9:size-guide:added', {
            detail: { productId: current.productId || this.product.id, variantId: current.variant.id, quantity: current.qty, sellingPlanId: current.plan.id, response: data }
          }));
        }.bind(this))
        .catch(function (error) {
          console.error(LOG, error);
          this.showMessage(errorMessage(error));
        }.bind(this))
        .then(function () {
          this.busy = false;
          this.addButton.removeAttribute('aria-busy');
          this.addButton.textContent = this.addLabel;
          this.addButton.disabled = !this.current;
        }.bind(this));
    }

    open(opener) {
      if (!this.dialog || this.dialog.open) return;
      this.opener = opener || null;
      clearTimeout(this._closeTimer);
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      /* theme scroll lock (global.js); a failure there must not leave the drawer half open */
      try {
        if (typeof window.lockBodyPosition === 'function') window.lockBodyPosition();
      } catch (error) {
        console.error(LOG, error);
      }
      document.documentElement.classList.add('k9-sg-locked');
      /* commit the closed position, then slide in (no requestAnimationFrame: it is paused in background tabs) */
      void this.dialog.offsetWidth;
      this.dialog.classList.add('is-open');
    }

    close(options) {
      if (!this.dialog || !this.dialog.open || this._closing) return;
      var restoreFocus = !(options && options.restoreFocus === false);
      this._closing = true;
      this.dialog.classList.remove('is-open');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this._closeTimer = setTimeout(function () {
        this._closing = false;
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else this.dialog.removeAttribute('open');
        try {
          if (typeof window.unlockBodyPosition === 'function') window.unlockBodyPosition();
        } catch (error) {
          console.error(LOG, error);
        }
        document.documentElement.classList.remove('k9-sg-locked');
        if (restoreFocus && this.opener && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
      }.bind(this), reduce ? 0 : ANIMATION_MS);
    }
  }

  window.customElements.define('k9-size-guide', K9SizeGuide);

  /* one delegated listener for every "Size Guide" link (also links re-rendered by variant changes) */
  document.addEventListener('click', function (event) {
    var opener = event.target && event.target.closest ? event.target.closest('[data-k9-size-guide-open]') : null;
    if (!opener) return;
    var guide = document.querySelector('k9-size-guide[data-product-id="' + opener.getAttribute('data-k9-size-guide-open') + '"]');
    if (!guide || typeof guide.open !== 'function') return;
    event.preventDefault();
    guide.open(opener);
  });
})();
